export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export const initialFilter = {
  filter: {
    name: ""
  },
  pageNumber: 1,
  pageSize: 10
};

export const NOTIFICATION_TYPE = {
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
  SMS: "SMS"
};

export const NOTIFICATION_TYPE_ARRAY = [
  { value: NOTIFICATION_TYPE.EMAIL, label: NOTIFICATION_TYPE.EMAIL },
  {
    value: NOTIFICATION_TYPE.WHATSAPP,
    label: NOTIFICATION_TYPE.WHATSAPP
  },
  { value: NOTIFICATION_TYPE.SMS, label: NOTIFICATION_TYPE.SMS }
];
